
import React, { useRef, useState } from 'react';

import { getToken, local_utc_timestamp } from '../../../helpers/Helper';
import { GET_EMPLOYEES_LIST, POST_EMPLOYEE_LASER_REPORTS } from '../../../helpers/url_helper';
import useMounted from '../../../hooks/useMounted';
import SimpleReactValidator from 'simple-react-validator';


import { useTranslation } from 'react-i18next';
import { get } from '../../../helpers/api_helper';
import { toast } from 'react-toastify';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Select from 'react-select';

const EmployeeLaserReports = () => {
    const { t } = useTranslation();
    const [employees, setEmployees] = useState([]);

    const simpleValidator = useRef(new SimpleReactValidator());
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [, forceUpdate] = useState();

    const [filter_option, setFilterOption] = useState({
        startDate: local_utc_timestamp(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
        endDate: local_utc_timestamp(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)),
        employeeId: '',
        offset: -new Date().getTimezoneOffset()
    });


    useMounted(() => {
        get_employees();
    })

    const get_employees = async () => {
        var api_res = await get(GET_EMPLOYEES_LIST);
        if (api_res.status) {
            setEmployees(api_res.data.employees.map(employee => ({
                value: employee.employeeId,
                label: `${employee.name} (E-${employee.employeeId})`
              })));
        } else {
            toast.error(api_res.message);
        }
    }

    // input text change handler
    const handleInputChangeFilter = (event) => {
        filter_option[event.target.name] = event.target.value;
        setFilterOption({ ...filter_option });
    }

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            try {
                SetButtonDisabled(true);
                const response = await fetch(`${POST_EMPLOYEE_LASER_REPORTS}`, {
                    method: "POST",
                    headers: {
                        Authorization: `${getToken()}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(filter_option),
                });
                if (response.ok) {
                    const blob = await response.blob();
                    const url = URL.createObjectURL(blob);
                    window.open(url, '_blank');
                }
                SetButtonDisabled(false);
            } catch (error) {
                toast.error(error.message);
                SetButtonDisabled(false);
            }
        }
    }

    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='mt-1'>{t('reports.employeeLaserReports.title')} </h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                    {/* <Link to='/attendance/add' className='btn btn-sm btn-primary'>+ {t('add')}</Link> */}
                                </div>
                            </div>
                            <hr />

                            <div className='row mb-3'>
                                <div className='col-sm-3 mb-3'>
                                    <label className='form-label text-capitalize'>{t('reports.employeeLaserReports.startDate')}</label>
                                    <DatePicker name='startDate' className='form-control'
                                        selected={filter_option.startDate} onChange={(date) => {
                                            handleInputChangeFilter({ target: { name: 'startDate', value: local_utc_timestamp(date) } })
                                        }}
                                        dateFormat="dd/MM/yyyy"
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                </div>
                                <div className='col-sm-3 mb-3'>
                                    <label className='form-label text-capitalize'>{t('reports.employeeLaserReports.endDate')}</label>
                                    <DatePicker name='endDate' className='form-control'
                                        selected={filter_option.endDate} onChange={(date) => {
                                            handleInputChangeFilter({ target: { name: 'endDate', value: local_utc_timestamp(date) } })
                                        }}
                                        dateFormat="dd/MM/yyyy"
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                </div>
                                <div className='col-sm-3 mb-3'>
                                    <label className='form-label text-capitalize'>{t('reports.employeeLaserReports.employees')}</label>
                                    <Select
                                        name='employeeId'
                                        value={employees.find(emp => emp.value === filter_option.employeeId) || null}
                                        onChange={(value) => {handleInputChangeFilter({target : {name : 'employeeId', value : value.value}})}}
                                        options={employees}
                                    />
                                    {simpleValidator.current.message('name', filter_option.employeeId, 'required', {
                                        messages: {
                                            required: t('payment.formError.employeeRequired')
                                        }
                                    })}
                                </div>
                                <div className='col-sm-3 mb-3 pt-4'>
                                    <button type='button' onClick={handleSubmit} disabled={ButtonDisabled} className='btn btn-primary me-3'>{ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {t('generate')} </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default EmployeeLaserReports;